import React, { useState, useEffect } from "react";
import { GetStaticProps } from "next";

import ScrollButton from "@/components/ScrollButton";

import SiteHead from "@/layouts/Head";
import Layout from "@/layouts/Layout";

import styles from "@/styles/home.module.scss";

interface FeedbackComment {
    comment_text: string;
    comment_time: string;
    item_title: string;
};

// const Home = (props: { feed: FeedbackComment[] }) => {
const Home = () => {
	// const [feedbackList, setFeedbackList] = useState<FeedbackComment[] | null>(null);

	// useEffect(() => {
	// 	if (props.feed) {
	// 		setFeedbackList(props.feed);
	// 	}
	// }, [props]);

	const convertDate = (dateString: string): string => {
		const date = new Date(dateString);
	
		const day = date.getDate();
		const month = date.toLocaleDateString("en-GB", { month: "long" });
		const year = date.getFullYear();
	
		return `${day} ${month} ${year}`;
	};

	// const feedbackCards = feedbackList && feedbackList.map(fbc => (
	// 	<li key={fbc.comment_time} className={styles["feedback-card"]}>
	// 		<p className={styles["feedback-item"]}>{fbc.item_title}</p>
	// 		<p className={styles["feedback-comment"]}>"{fbc.comment_text}"</p>
	// 		<div className={styles["feedback-row"]}>
	//                <span>{convertDate(fbc.comment_time)}</span>
	// 		</div>
	// 	</li>
	//    ));

	// const googleRatingBadge = (): JSX.Element => {
	//
	// 	return (
	// 		<div className="feedback-google-badge" dangerouslySetInnerHTML = {{
	// 			__html: `
	// 				<g:ratingbadge merchant_id="264991854"></g:ratingbadge>
	// 			`
	// 		}} />
	// 	);
	// };

	return (
		<React.Fragment>
			<SiteHead title="Home" />

			<Layout>
                <div className={styles["container"]}>
                    {/* <div className={styles["feedback-container"]}> */}
                    {/*     <h1 className={styles["feedback-title"]}>What our customers say:</h1> */}
                    {/*     {/* {googleRatingBadge()} */}
                    {/*     <ul className={styles["feedback-list"]}> */}
                    {/*         {feedbackCards} */}
                    {/*     </ul> */}
                    {/* </div> */}
                </div>
			</Layout>
			<ScrollButton scrollLength={400} />
		</React.Fragment>
	);
};

// export const getStaticProps: GetStaticProps = async () => {
//     const url: string = `${process.env.API_ADDRESS}/feedback?fq=build`;
//     // const url: string = `http://dcp_dev_api:3000/v2/feedback?fq=build`;
//
//     const response = await fetch(url);
//     const result = await response.json();
//
//     return {
//         props: { 
//             feed: result.data 
//         },
//         revalidate: parseInt(process.env.REVALIDATE_FEEDBACK as string)
//     };
// };

export default Home;
